import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { uuid } from 'uuidv4';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, scrollTo, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';
import SpeakersGrid from '../../components/SpeakersGrid';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Publicas from './modules/publicas';
import Programacao from '../Program';
import Vimeo from '../../components/Vimeo';
import GaleriaFotos from '../GaleriaFotos';
import ContagemRegressiva from '../../components/ContagemRegressiva';
import Logo from '../../components/Logo';
import Speakers from '../Speakers';
import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';
import Program from '../../components/Program';
import Youtube from '../../components/Youtube';
import Products from '../Products';
import Sobre from '../Sobre';
import { WebGL } from '../../components/WebglAnimation';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { addModal, removeModal } = useModal();
  const formRef = useRef<FormHandles>(null);
  const [cardLayout, setCardLayout] = useState([] as Array<JSX.Element>);
  const { readPages } = usePages();

  const [pages, setPages] = useState(readPages());

  /*
  useEffect(() => {
    const keyModal = 'uModal';
    addModal({
      key: keyModal,
      title: 'Seja bem-vindo!',
      content: (
        <>
          <p>
            A área de transmissão já está aberta. 
{' '}
<br />
            Clique abaixo para acessar!
          </p>

          <br />
          <a href="/login" title="login">
            <Button>Acessar Palestras</Button>
          </a>
          <br />
          <p>
            Os certificados já estão disponíveis! 
{' '}
<br />
          </p>

          <a href="/certificados" title="login">
            <Button>Visualizar Certificados</Button>
          </a>
        </>
      ),
    });
  }, []);

  */

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        const { email, password } = data;

        await signIn({ email, password });
        history.push('/dashboard');
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, history],
  );

  const buildCard: React.FC<IPublicData> = ({ icon, title, text }) => {
    return (
      <div
        onClick={() =>
          setCardLayout([<Publicas icon={icon} text={text} title={title} />])
        }
      >
        {icon({})}
        <p>{title}</p>
      </div>
    );
  };

  return (<>
    <Capa style={{marginTop: '150px'}}>
      <div style={{display:'flex', alignItems: 'center', justifyContent: 'center'}}>
        <img className="imgCapa lightPulse" src="/assets/icon.png"/>
      </div>
       <div className="p50 capaTitle">
       <h1>X Congresso Gaúcho de Pneumologia</h1>
       <h2 style={{fontSize: '18px',}} ><br/>
<strong style={{background:"rgb(240,100,0)", padding: '10px'}}>Pré Congresso - 07 de outubro de 2021 - 19h</strong><br/><br/>
Evento: 14 a 16 de outubro de 2021
</h2>
 

  
      
      
  
  </div>


    </Capa>
  
  <Capa>

  <Link  to="/certificados" style={{'margin': '10px'}}><button className="defaultButtonReverse">Certificados</button></Link>
   <Link  to="/login" style={{'margin': '10px'}}><button className="defaultButtonReverse">Acessar</button></Link>
  <Link  to="#" style={{'margin': '10px'}} onClick={(e) => scrollTo(e,'evento')}><button className="defaultButtonReverse">Evento</button></Link>
  <Link  to="#" style={{'margin': '10px'}} onClick={(e) => scrollTo(e,'comissao')}><button className="defaultButtonReverse">Comissão</button></Link>
  <Link to="/trabalhos-cientificos"  style={{'margin': '10px'}}><button className="defaultButtonReverse">Acessar trabalhos</button></Link>
 </Capa>

  

  <Capa id="evento" style={{maxWidth: '1300px', margin: 'auto', marginTop:'150px'}}>
    <div className="p50 capaTitle" style={{padding: '20px', maxWidth:'100%'}}>
    <h1>Sobre o</h1>
    <h2> X Congresso Gaúcho de Pneumologia </h2><br/>
<p>É com imensa satisfação que a Sociedade de Pneumologia e Tisiologia do Rio Grande do Sul, convida a todos para o X Congresso Gaúcho de Pneumologia que ocorrerá entre os dias 14 e 16 de outubro de 2021 em uma plataforma online inovadora. A exibição do Pré Congresso será no dia 07 de outubro. 
<br/><br/>O programa científico do X Congresso Gaúcho de Pneumologia pretende oferecer não só o crescimento do aprendizado bem como oportunizar o diálogo, troca de experiência e conhecimento entre palestrantes e participantes. Venha dividir conosco esta experiência que incentiva o aprimoramento da Comunidade Científica da Pneumologia Gaúcha. 
<br/><br/>
Desejamos a todos um ótimo evento!<br/><br/>
<strong>Dr. Gustavo Chatkin</strong>
<br/>Presidente - SPTRS<br/><br/>

<strong>Dr. Marcelo Tadday Rodrigues </strong>
<br/>Diretor Científico - SPTRS</p>

    </div>

    <div className="p50">
      <img src="/apoio/palestra2.jpeg" style={{width: '100%', maxWidth: '400px'}}/>
    </div>
  </Capa>

  

<Capa id="programacao" style={{flexDirection:'column',marginTop:'150px', alignItems: 'center', justifyContent:'flex-start'}}>
<h1>Programação</h1>

<img src="/apoio/programacao5.jpg" style={{width: '100%', maxWidth: '800px', margin: '20px auto'}}/>
  </Capa>

  <Capa id="comissao" style={{ marginTop:'150px', alignItems: 'flex-start'}}>

<div className="p50 capaTitle">

<h1>Comissão Organizadora</h1>
<h2> <br/><br/></h2>
<strong>Dr. Gustavo Chatkin </strong><br/>
<strong>Dr. Paulo Roberto Goldenfum </strong><br/>
<strong>Dr. Marcelo Tadday Rodrigues </strong><br/>
<strong>Dra. Daniela Cavalet Blanco </strong><br/>
<strong>Dr. Douglas Zaione Nascimento  </strong><br/>
<strong>Dra. Dayse Carneiro Alt </strong><br/>
<strong>Dr. Christiano Perin </strong><br/>
<strong>Dr. Adalberto Sperb Rubin </strong><br/>
<strong>Dra. Claudia Fontoura Dias  </strong><br/>
<strong>Dra. Fabíola Adélia Perin </strong><br/>
<strong>Dr. Eduardo Sperb Pilla </strong><br/>
<strong>Dr. Diego Djones Brandenburg  </strong><br/>
<strong>Dra. Juliessa Florian</strong><br/>


</div>
<div className="p50 capaTitle">
<h1>Diretoria da SPTRS </h1><h2>GESTÃO 2020-2021</h2><br/><br/>
<strong>PRESIDENTE:</strong> Dr. Gustavo Chatkin <br/><br/>
<strong>VICE-PRESIDENTE:</strong> Dr. Paulo Roberto Goldenfum <br/><br/>
<strong>DIRETOR CIENTÍFICO:</strong> Dr. Marcelo Tadday Rodrigues <br/><br/>
<strong>DIRETOR FINANCEIRO:</strong> Dra. Daniela Cavalet Blanco <br/><br/>
<strong>DIRETOR ADMINISTRATIVO:</strong> Dr. Douglas Zaione Nascimento <br/><br/>
<strong>DIRETOR EXERCÍCIO PROFISSIONAL:</strong> Dra. Dayse Carneiro Alt <br/><br/>
<strong>DIRETOR DIVULGAÇÃO:</strong> Dr. Christiano Perin <br/><br/>

<strong>DIRETOR ASSUNTOS EXTRAORDINÁRIOS:</strong> Dr. Adalberto Sperb Rubin <br/><br/>
<strong>COORDENADOR DE AÇÕES CONTRA A TUBERCULOSE:</strong> Dra. Cláudia Fontoura Dias <br/><br/>
<strong>DEPARTAMENTO DE CIR. TORÁCICA:</strong> Dr. Eduardo Sperb Pilla  <br/><br/>
<strong>DEPTO DE PNEUMOPATIAS OCUPACIONAIS E AMBIENTAIS:</strong> Dr. Carlos N. Tietboehl Filho <br/><br/>
<strong>DEPARTAMENTO DE PNEUMOPEDIATRIA:</strong> Dr. Diego Djones Brandenburg <br/><br/>
<strong>DEPARTAMENTO DE ENDOSCOPIA RESPIRATÓRIA:</strong> Dr. Dra. Fabíola Adélia Perin <br/><br/>
</div>
  </Capa>
    </>
  );
};
export default SignIn;
